export default "__VITE_ASSET__BYn36urj__"